import { observable, toJS } from "mobx";
import { sortCaret } from './../../../comum/components/Icones';
import EntrepostagemService from "../../../../services/EntrepostagemService";
import { formatarDataCustomHTML } from './../../../../utils/formatar';


export default class RelatorioSinteticoStore {
    
    @observable colunas;
    
    @observable listaEntrepostagem;
    @observable listaClientes;
    @observable listaStatus;

    @observable loadingTable;
    @observable loadingPage;
    
    @observable ce;
    @observable da;
    @observable status;
    @observable cliente;

    constructor() {

        this.listaEntrepostagem = [];
        this.listaStatus = [];
        this.listaClientes = [];

        this.clienteReq = null;
        this.statusReq = "";
        this.cliente = null;
        this.status = null;
        this.ce = null;
        this.da = "";

        this.loadingTable = false;
        this.loadingPage = false;

        this.colunas = this.colunasEntrepostagem;

        this.service = new EntrepostagemService();

        this.listarStatus();
        this.listarClientes();
    }


    copiaListaEntrepostagem = () => {
        return toJS(this.listaEntrepostagem);
    }


    listarClientes = () => {
        //Fazer loading da página
        this.loadingPage = true;
        this.service.ListarClientes().then(response => {
            if(response && response.data) {
                this.listaClientes = response.data.map(elem => ({label: elem.Value, value: elem.Key}));
                if(this.listaClientes.length === 1) {
                    this.cliente = this.listaClientes[0];
                    this.clienteReq = this.listaClientes[0].value
                }
            }
        }).catch(err => {
            console.error(err);

        }).finally(() => {
            this.loadingPage = false;
        });
    }
    
    listarStatus = () => {
        //Fazer loading da página
        this.loadingPage = true;
        this.service.ListarStatus().then(response => {
            if(response && response.data) {
                this.listaStatus = response.data.map(elem => ({label: elem.Descr, value: elem.Codigo}));
                if(this.listaStatus.length === 1) {
                    this.status = this.listaStatus[0];
                    this.statusReq = this.listaStatus[0].value
                }
            }
        }).catch(err => {
            console.error(err);

        }).finally(() => {
            this.loadingPage = false;
        });;
    }

    setCliente = (event) => {
        this.cliente = event;
        if(event) {
            this.clienteReq = event.value;
        } else {
            this.clienteReq = null;
        }
    }
    
    setStatus = (event) => {
        this.status = event;
        if(event) {
            this.statusReq = event.value;
        } else {
            this.statusReq = "";
        }

    }

    setDa = (event) => {
        console.log(event);
        if(event) {
            if(event !== "" && event !== null) {
                this.da = event;
            }
        } else {
            this.da = "";
        }
    }

    setCe = (event) => {
        console.log(event);
        if(event) {
            if(event !== "" && event !== null) {
                this.ce = event;
            }
        } else {
            this.ce = null;
        }
    }

    statusFormatter = (cell) => {
        if(cell) {
            if(this.listaStatus.length > 0) {
                const status = this.listaStatus.find(elem => elem.value === cell);
                if(status) {
                    return status.label;
                } else {
                    return cell;
                }
            } else {
                return cell;
            }
        } else {
            return '---';
        }
    }
    /**
     * Procurar adaptar depois com infinite scroll
     */
    listarEntrepostagem = () => {
        this.loadingTable = true;
        this.service.ListarEntrepostagem(this.clienteReq, this.statusReq, this.ce, this.da).then(response => {
            if(response && response.data) {
                this.listaEntrepostagem = response.data;
            } else {
                //mensagem de erro aqui;
            }
        }).catch(err => {
            console.error(err);
            //mensagem de erro aqui
        }
        ).finally(() => {
            this.loadingTable = false;
        });
    }

    colunasEntrepostagem = [
        {
            dataField:"Ce",
            text: "CE",
            sortable: true,
            sortCaret: sortCaret,
            headerAlign: () => 'left'
        },
        {
            dataField:"ApelidoCliBras",
            text: "Cliente",
            sortable: true,
            sortCaret: sortCaret,
            headerAlign: () => 'left'
        },
        {
            dataField:"DaFormat",
            text: "D.A.",
            sortable: true,
            sortCaret: sortCaret,
            headerAlign: () => 'left'
        },
        {
            dataField:"DtValidade",
            text: "Validade do regime",
            sortable: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML,
            headerAlign: () => 'left'
        },
        {
            dataField:"DtAbandono",
            text: "Prazo de Abandono",
            sortable: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML,
            headerAlign: () => 'left'
        },
        {
            dataField:"NumProcesso",
            text: "Nº do Processo",
            sortable: true,
            sortCaret: sortCaret,
            headerAlign: () => 'left'
        },
        {
            dataField:"IndStatus",
            text: "Status",
            sortable: true,
            sortCaret: sortCaret,
            formatter: (cell) => this.statusFormatter(cell),
            headerAlign: () => 'left'
        },
        {
            dataField:"DscLocal",
            text: "Localização",
            sortable: true,
            sortCaret: sortCaret,
            headerAlign: () => 'left'
        }
    ]
}


// WEBPACK FOOTER //
// ./src/modules/entrepostagem/relatoriosintetico/stores/RelatorioSinteticoStore.js